import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a593166e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aigame-wrap" }
const _hoisted_2 = { class: "aigame-header-content" }
const _hoisted_3 = { class: "aigame-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static.wecity.qq.com/miying/while-logo-0a52c4e00ecbaef268084b329936d305.png",
    alt: "",
    class: "aigame-logo-img"
  })
], -1))
const _hoisted_5 = { class: "aigame-header-list" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "aigame-header-item active" }, "首页", -1))
const _hoisted_7 = { class: "aigame-banner" }
const _hoisted_8 = { class: "t-container" }
const _hoisted_9 = { class: "aigame-banner-bd" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-banner-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static.wecity.qq.com/miying/banner-title-4efa935f4768682f025aaec7d9fac379.png",
    alt: "",
    class: "aigame-banner-title__img"
  })
], -1))
const _hoisted_11 = { class: "aigame-banner-subtitle" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "aigame-banner-text" }
const _hoisted_14 = { class: "aigame-container aigame-container--1" }
const _hoisted_15 = { class: "aigame-container__inner" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "aigame-leftmenu-item__hd" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-leftmenu-item__bd" }, null, -1))
const _hoisted_19 = {
  class: "aigame-container aigame-container--2",
  id: "aigame-introduce"
}
const _hoisted_20 = { class: "aigame-container__inner" }
const _hoisted_21 = { class: "aigame-introduce" }
const _hoisted_22 = { class: "t-container" }
const _hoisted_23 = { class: "aigame-container aigame-container--3" }
const _hoisted_24 = { class: "aigame-container__inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sigup_dialog = _resolveComponent("sigup-dialog")!
  const _component_end_signup_dialog = _resolveComponent("end-signup-dialog")!
  const _component_race_channel = _resolveComponent("race-channel")!
  const _component_race_flow = _resolveComponent("race-flow")!
  const _component_race_prize = _resolveComponent("race-prize")!
  const _component_race_juries = _resolveComponent("race-juries")!
  const _component_race_rank = _resolveComponent("race-rank")!
  const _component_race_rules = _resolveComponent("race-rules")!
  const _component_race_footer = _resolveComponent("race-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("li", {
            class: "aigame-header-item",
            onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('./faq'))
          }, "常见问题"),
          _createElementVNode("li", {
            class: "aigame-header-item",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toPerson && _ctx.toPerson(...args)))
          }, _toDisplayString(_ctx.topRight), 1),
          (_ctx.hasLogin)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "aigame-header-item",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
              }, "退出登录"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.raceInfo?.Title) + " ", 1),
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.raceInfo?.SubTitle), 1)
          ]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.raceInfo?.Info), 1),
          (_ctx.raceInfo?.hasModify || _ctx.raceInfo?.hasAdd)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "aigame-banner-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loginToTaop && _ctx.loginToTaop(...args)))
              }, "我要报名"))
            : _createCommentVNode("", true),
          _createVNode(_component_sigup_dialog, {
            dialogShow: _ctx.dialogShow,
            onClose: _ctx.closeDialog,
            showClose: true
          }, null, 8, ["dialogShow", "onClose"]),
          _createVNode(_component_end_signup_dialog, {
            dialogShow: _ctx.endDialogShow,
            onClose: _ctx.endCloseDialog,
            showClose: true
          }, null, 8, ["dialogShow", "onClose"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: _normalizeClass(['aigame-leftmenu', _ctx.fixMenu ? 'aigame-leftmenu-top' : ''])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItem, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['aigame-leftmenu-item', _ctx.menuActive === index ? 'cur' : '']),
              onClick: ($event: any) => (_ctx.onClick(item.className))
            }, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1),
              _hoisted_18
            ], 10, _hoisted_16))
          }), 128))
        ], 2),
        _createVNode(_component_race_channel),
        _createVNode(_component_race_flow),
        _createVNode(_component_race_prize)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_race_juries)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_race_rank),
        _createVNode(_component_race_rules),
        _createVNode(_component_race_footer)
      ])
    ])
  ]))
}